
import TextAccordion from './accordion_old';
export { default as TextAccordionControllable } from './accordion';

export default TextAccordion;
